export const BOOK = "booking/book";
export const CANCEL_BOOK = "booking/cancel_booking";
